// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'flow-process';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.688 11.063a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm0 6.375a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75z' />
    <path d='M6.938 5.063v9a1.5 1.5 0 0 0 1.5 1.5h3.374M6.938 9.188h4.875' />
    <path d='M11.438 2.813a2.25 2.25 0 0 1-2.25 2.25h-4.5a2.25 2.25 0 1 1 0-4.5h4.5a2.25 2.25 0 0 1 2.25 2.25z' />
  </g>
);

export const viewBox = '0 0 18 18';
